function checkBrandImageExists(imgObject) {
    const img = new Image();
  
    img.onload = () => {
      imgObject.show();
    };
  
    img.onerror = () => {
      imgObject.hide();
    };

   img.src = imgObject.attr('src')
}

$(document).ready(() => {
  const VENDOR_IMAGE = $('.product-single__vendor img');
  checkBrandImageExists(VENDOR_IMAGE)
})